import { render, staticRenderFns } from "./supplierManager.vue?vue&type=template&id=387f346f&scoped=true"
import script from "./supplierManager.vue?vue&type=script&lang=js"
export * from "./supplierManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f346f",
  null
  
)

export default component.exports